import { render, staticRenderFns } from "./message.vue?vue&type=template&id=54a2eb30&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=54a2eb30&prod&lang=less&"
import style1 from "./message.vue?vue&type=style&index=1&id=54a2eb30&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2eb30",
  null
  
)

export default component.exports